/**
 * GFG-405 — the gift-link quantity is always a whole number within LINK_QTY_MIN..LINK_QTY_MAX
 * (1..10,000, the API's bounds), wherever it is typed or stepped (the campaign builder and the Add
 * gift links wizard share these rules).
 */
import { LINK_QTY_MAX, LINK_QTY_MIN } from "@giftforward/naming";

/**
 * A whole number inside the range. NaN reads as the minimum; +Infinity clamps to the maximum and
 * -Infinity to the minimum (the builder's original `Math.min(MAX, Math.max(MIN, n))` behaviour).
 */
export function clampLinkQty(n: number): number {
  if (Number.isNaN(n)) return LINK_QTY_MIN;
  return Math.min(LINK_QTY_MAX, Math.max(LINK_QTY_MIN, Math.trunc(n)));
}

/** The quantity committed from the typed text (on blur): unreadable text is the minimum. */
export function commitLinkQtyText(text: string): number {
  return clampLinkQty(Number.parseInt(text, 10));
}

/** One step up or down from the typed text; an empty or unreadable box counts as 0. */
export function stepLinkQty(text: string, delta: 1 | -1): number {
  return clampLinkQty((Number.parseInt(text, 10) || 0) + delta);
}
